/* eslint-disable jsx-a11y/control-has-associated-label */
import * as React from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';
import localforage from 'localforage';
import { IWidgetGraph } from '../../OnlinePanel/OnlinePanelState';
import { URL_GRAPHS, URL_THROTTLE } from '../../../router/constants';
import { isGraphOpenAtom, throttleWidgetGraphAtom } from '../../Graphs/GraphState';
import useAnalytics from '../../../hooks/useAnalytics';
import ThrottleOnline from '../../Graphs/Throttle';

export default function SpeedWidgetGraph(props: { vehicleId: number }): JSX.Element {
  const { trackEvent } = useAnalytics();
  const { formatMessage: f } = useIntl();
  const [throttleWidgetGraph, setThrottleWidgetGraph] = useRecoilState<IWidgetGraph | null>(
    throttleWidgetGraphAtom
  );
  const setIsGraphOpen = useSetRecoilState<boolean | number>(isGraphOpenAtom);

  const closeWidgetGraph = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    trackEvent(['Throttle Widget', 'click', 'Close widget graph']);
    setThrottleWidgetGraph(null);
    localforage.setItem('widgetGraph', null);
    setIsGraphOpen(false);
  };

  const openThrottlePage = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    trackEvent(['Throttle Widget', 'click', 'Open Throttle page to new window']);
    window.open(`${URL_GRAPHS}${URL_THROTTLE}/${throttleWidgetGraph?.vehicleId}`, '_blank');
  };

  const getDate = () => {
    if (throttleWidgetGraph && throttleWidgetGraph.timestamp) {
      return dayjs(throttleWidgetGraph.timestamp).format('DD.MM.YYYY');
    }
    return '';
  };

  React.useEffect(() => {
    trackEvent(['Throttle Widget', 'show', 'Widget graph']);
    return () => {
      if (throttleWidgetGraph && throttleWidgetGraph.timestamp !== undefined) {
        setThrottleWidgetGraph(null);
        trackEvent(['Throttle Widget', 'close', 'Widget graph']);
        localforage.setItem('widgetGraph', null);
        setIsGraphOpen(false);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ background: '#fff', borderRadius: '4px', margin: '2px', width: '756px' }}>
      <div
        style={{
          padding: '10px 14px 10px 10px',
        }}
      >
        <div className="">
          <div style={{ display: 'inline-flex' }}>
            <a
              href=""
              onClick={closeWidgetGraph}
              className="cmd-icon cmd-icon-arrow-left-ext"
              title={f({ id: 'graph.onlinepanel.back' })}
              style={{
                color: '#494949',
                marginRight: '12px',
                top: '2px',
                position: 'relative',
              }}
            />
            {f({ id: 'enum.onlineMap.widget.types.throttle' })}: {getDate()}
          </div>
          <div
            style={{
              float: 'right',
              padding: '2px 10px',
              textAlign: 'center',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
            className="e-button--gray mb-2"
            onClick={openThrottlePage}
          >
            {f({ id: 'table.detailBtn' })}
          </div>
        </div>
      </div>
      <div style={{ padding: '0 0 0 10px' }}>
        <React.Suspense fallback={<div>Loading...</div>}>
          <ThrottleOnline vehicleId={props.vehicleId} />
        </React.Suspense>
      </div>
    </div>
  );
}
